import { render, staticRenderFns } from "./Complaint_Details.vue?vue&type=template&id=efc6771e&scoped=true"
import script from "./Complaint_Details.vue?vue&type=script&lang=js"
export * from "./Complaint_Details.vue?vue&type=script&lang=js"
import style0 from "./Complaint_Details.vue?vue&type=style&index=0&id=efc6771e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc6771e",
  null
  
)

export default component.exports